import { makeRequest } from '../base/axios.ts'

export default {
  fetchTimelineComments: function (timelineId) {
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/comments`,
      method: 'get',
      requestId: `get-timeline-comments-for-timeline-${timelineId}`,
    })
  },

  changeCommentsVisibility: function (ids, visible) {
    const data = {
      comment_ids: ids,
      visible,
    }
    return makeRequest({
      url: '/api/v1/comments/bulk_change_visibility',
      method: 'put',
      data,
      requestId: 'change-comment-visibility',
    })
  },
}
